export const Constants = {
  TAG_NAME: 'pop-manager-and-team-component',
  NESTED_COMPONENTS: ['pop-no-data-available-component'],
  MANAGER_AND_TEAM: 'Manager and team',
  MANAGER_AND_TEAM_UNAVAILABLE: 'Manager and team unavailable',
  VIEW_BIO: 'View Bio',
  YEAR_AT_TROWE_PRICE: 'years at T. Rowe Price',
  YEARS_OF_EXPERIENCE: 'years industry experience',
  BEACON_SYSTEM_BREAKPOINT_X_LARGE: '--beacon-system-breakpoint-x-large',
  NORMAL: 'normal',
  MINI: 'mini',
} as const;
